import SearchIcon from '@mui/icons-material/Search';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { triggerSearch } from '../searchSlice';

const MOBILE_BREAKPOINT = 640;

const FindABlogSearchComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [query, setQuery] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handleSearch = () => {
    dispatch(triggerSearch(query));
    navigate(`/search-results?query=${encodeURIComponent(query)}`);
  };

  return (
    <div className="find-a-blog-search-wrapper">
      <div className="search-wrapper">
        <SearchIcon onClick={handleSearch} />
        <input
          type="search"
          className="search-input"
          placeholder={isMobile ? "Search" : "Search the Wildernet"}
          value={query}
          onChange={e => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          enterKeyHint="search"
        />
      </div>
    </div>
  );
};

export default FindABlogSearchComponent;
